import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, Injectable } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { SharedImportsModule } from './shared-modules/shared-imports.module';
import { PrimengImportsModule } from './shared-modules/primeng-imports.module';
import { RedirectGuardService } from './services/RedirectGuard.service';
import { HttpClientModule } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { SocketIoModule, Socket } from 'ngx-socket-io';
import { BaseServicesService } from './services/base-services.service';

@Injectable()
export class SocketConfigs extends Socket {
  constructor() {
    const baseService = new BaseServicesService();
    super({ url: baseService.getPath(), options: {} });
  }
}

@NgModule({
  declarations: [
    // DomSecurePipe, // ========= >>>>> pipe

    AppComponent,
  ],
  imports: [
    BrowserModule, // these modules should be imported only once in all application
    BrowserAnimationsModule,
    HttpClientModule,
    // DragToSelectModule.forRoot(),

    SharedImportsModule,
    PrimengImportsModule,

    AppRoutingModule,
    NgxUiLoaderModule,

    // NgxUiLoaderHttpModule.forRoot({exclude: ['http://localhost:4200'], showForeground: true}),

    // NgxUiLoaderHttpModule, // shows loader for every http request
    // NgxUiLoaderHttpModule.forRoot({ exclude: ['/api/not/show/loader', '/api/logout', 'https://external-domain.com/api/not/to/show'] });

    SocketIoModule,
  ],
  providers: [
    RedirectGuardService,
    MessageService,
    SocketConfigs,
    // MessageService
    // DomSecurePipe
    //   // DatePipe,
    //   // ComponentLoaderFactory,
    //   // PositioningService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
